import { render, staticRenderFns } from "./TraceabilityBackButton.vue?vue&type=template&id=03f0e23b&scoped=true"
import script from "./TraceabilityBackButton.vue?vue&type=script&lang=js"
export * from "./TraceabilityBackButton.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityBackButton.vue?vue&type=style&index=0&id=03f0e23b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f0e23b",
  null
  
)

export default component.exports